import { Component, OnInit } from "@angular/core";
import { ClareSystemDbService } from "@app/project/services/clare-system-db.service";
import { RouterService } from "@app/root-store/router.service";
import { Observable } from "rxjs";
import { switchMap, take, tap } from "rxjs/operators";

@Component({
    templateUrl: "./ovrc-container.component.html",
    styleUrls: ["./ovrc-container.component.scss"],
})
export class OvrcContainerComponent implements OnInit {
    redirect$: Observable<any>;

    constructor(private clareSystemDbService: ClareSystemDbService, private routerService: RouterService) {}

    ngOnInit() {
        // Example URL for this page: localhost:4200/ovrc?uuid=58:67:7F:93:8A:9F.000
        this.redirect$ = this.routerService.getQueryParams().pipe(
            take(1),
            switchMap(params => {
                const decodedUuid = decodeURIComponent(params?.uuid);
                return this.clareSystemDbService.getProjectIdByUuid(decodedUuid).pipe(
                    tap(id => {
                        let url = "accounts";

                        if (id) {
                            url += `/edit/${id}/summary`;
                        }

                        this.routerService.navigateToUrl([url]);
                    })
                );
            })
        );
    }
}
